<div id="betSettings">
    <mat-card
        class="mat-card settings"
        [ngClass]="{ betSettingsGK: gameCode == 'GK' || gameCode == 'EK' }"
    >
        <div class="content-container app-container">
            <h3>Ccy/Max/Profile</h3>
            <mat-form-field
                class="example-full-width"
                appearance="fill"
            >
                <mat-label>Ccy</mat-label>
                <input
                    matInput
                    placeholder="ccy"
                    value="{{ ccy }}"
                    [disabled]="disabledInputs"
                    #ccyInput
                />
            </mat-form-field>

            <mat-form-field
                class="example-full-width"
                appearance="fill"
                *ngIf="gameCode !== 'GK' && gameCode !== 'EK'"
            >
                <mat-label>Max payin</mat-label>
                <input
                    matInput
                    placeholder="Min payin"
                    [disabled]="disabledInputs"
                    #maxPayinInput
                />{{ maxPayin | roundNumber }}
            </mat-form-field>

            <mat-form-field
                class="example-full-width"
                appearance="fill"
                *ngIf="gameCode !== 'GK' && gameCode !== 'EK'"
            >
                <mat-label>Max payout</mat-label>
                <input
                    matInput
                    placeholder="Max payout"
                    [disabled]="disabledInputs"
                    #maxPayoutInput
                />{{ maxPayout | roundNumber }}
            </mat-form-field>

            <mat-form-field
                class="example-full-width"
                appearance="fill"
                *ngIf="gameCode !== 'GK' && gameCode !== 'EK'"
            >
                <mat-label>Profile</mat-label>
                <input
                    matInput
                    placeholder="Profile"
                    value="{{ profile }}"
                    [disabled]="disabledInputs"
                    #profileInput
                />
            </mat-form-field>
        </div>
    </mat-card>
    <mat-card class="mat-card mat-card2">
        <div>
            <div id="betIncrements">
                <h3>Bet increments</h3>
                <div
                    id="incrementsHolder"
                    class="settings"
                >
                    <div id="incHolderPiece increments">
                        <div
                            id="tabOne"
                            *ngFor="
                                let item of incSource;
                                let i = index;
                                let last = last
                            "
                        >
                            <mat-form-field
                                *ngIf="i <= 9"
                                class="example-full-width"
                                appearance="fill"
                                class="incs"
                            >
                                <mat-label>Step {{ i + 1 }}</mat-label>
                                <input
                                    matInput
                                    placeholder="{{ item }}"
                                    [disabled]="disabledInputs"
                                    class="increments"
                                />{{ item | roundNumber }}
                            </mat-form-field>
                        </div>
                    </div>
                    <div id="incHolderPiece increments2">
                        <div
                            id="tabOne"
                            *ngFor="let item of incSource; let i = index"
                        >
                            <mat-form-field
                                *ngIf="i > 9 && i < 20"
                                class="example-full-width"
                                appearance="fill"
                                class="incs"
                            >
                                <mat-label>Step {{ i + 1 }}</mat-label>
                                <input
                                    matInput
                                    placeholder="{{ item }}"
                                    [disabled]="disabledInputs"
                                    class="increments"
                                />{{ item | roundNumber }}
                            </mat-form-field>
                        </div>
                    </div>
                    <div id="incHolderPiece increments3">
                        <div
                            id="tabOne"
                            *ngFor="
                                let item of incSource;
                                let i = index;
                                let last = last
                            "
                        >
                            <mat-form-field
                                *ngIf="i >= 20"
                                class="example-full-width"
                                appearance="fill"
                                class="incs"
                            >
                                <mat-label>Step {{ i + 1 }}</mat-label>
                                <input
                                    matInput
                                    placeholder="{{ item }}"
                                    [disabled]="disabledInputs"
                                    class="increments"
                                />{{ item | roundNumber }}
                            </mat-form-field>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </mat-card>

    <!-- TEMPORARY: Edit and Save buttons commented out - bet settings changes through this endpoint are temporarily disabled -->
    <!-- <div id="editSavebtns">
        <button
            mat-button
            mat-raised-button
            type="button"
            (click)="enableEdditing()"
        >
            Edit
        </button>
        <button
            mat-button
            mat-raised-button
            type="button"
            [disabled]="disabledInputs"
            (click)="saveSettings()"
            [ngClass]="{ saveButtonActive: saveButtonActive }"
        >
            Save
        </button>
    </div> -->
</div>
